import { GET_ADMINS_RESPONSE, GET_ADMIN_DETAILS_RESPONSE } from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  adminDetails: {},
};

const admins = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ADMINS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case GET_ADMIN_DETAILS_RESPONSE:
      return {
        ...state,
        adminDetails: action.payload.adminDetails,
      };
    default:
      return state;
  }
};

export default admins;
